<p-menubar *ngIf="items" [model]="items" [autoDisplay]="false" 
[styleClass]="isMobile()? 'mobile' : ''" 
[autoZIndex]="true" baseZIndex="10000"></p-menubar>

